module.exports = __webpack_public_path__ + "img/tian.d6fee99e.png";